import { grpcClientFactory } from './grpcClientFactory';
class CoordinateService {
    createAuthenticatedClient() {
        return grpcClientFactory.createAuthenticatedUserProjectsClient({ enableCompression: true });
    }
    async convertUTMToLatLong(utm) {
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated');
        }
        return new Promise((resolve, reject) => {
            try {
                const Req = proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest;
                const UTMMsg = proto.landscope.mapviewer.v1.UTMCoordinate;
                const utmMsg = new UTMMsg();
                utmMsg.setZone(utm.zone);
                utmMsg.setHemisphere(utm.hemisphere);
                utmMsg.setEasting(utm.easting);
                utmMsg.setNorthing(utm.northing);
                const grpcReq = new Req();
                grpcReq.setUtm(utmMsg);
                const client = this.createAuthenticatedClient();
                client.convertUTMToLatLong(grpcReq, {}, (err, response) => {
                    if (err) {
                        reject(new Error(err.message || 'Failed to convert UTM to LatLong'));
                        return;
                    }
                    const success = response.getSuccess();
                    if (!success) {
                        resolve({
                            success: false,
                            error: response.getError() || 'Conversion failed'
                        });
                        return;
                    }
                    const latLong = response.getLatLong();
                    resolve({
                        success: true,
                        latLong: {
                            latitude: latLong.getLatitude(),
                            longitude: latLong.getLongitude()
                        }
                    });
                });
            }
            catch (error) {
                reject(error);
            }
        });
    }
    async convertLatLongToUTM(latLong) {
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated');
        }
        return new Promise((resolve, reject) => {
            try {
                const Req = proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest;
                const LatLongMsg = proto.landscope.mapviewer.v1.LatLongCoordinate;
                const latLongMsg = new LatLongMsg();
                latLongMsg.setLatitude(latLong.latitude);
                latLongMsg.setLongitude(latLong.longitude);
                const grpcReq = new Req();
                grpcReq.setLatLong(latLongMsg);
                const client = this.createAuthenticatedClient();
                client.convertLatLongToUTM(grpcReq, {}, (err, response) => {
                    if (err) {
                        reject(new Error(err.message || 'Failed to convert LatLong to UTM'));
                        return;
                    }
                    const success = response.getSuccess();
                    if (!success) {
                        resolve({
                            success: false,
                            error: response.getError() || 'Conversion failed'
                        });
                        return;
                    }
                    const utm = response.getUtm();
                    resolve({
                        success: true,
                        utm: {
                            zone: utm.getZone(),
                            hemisphere: utm.getHemisphere(),
                            easting: utm.getEasting(),
                            northing: utm.getNorthing()
                        }
                    });
                });
            }
            catch (error) {
                reject(error);
            }
        });
    }
}
export const coordinateService = new CoordinateService();
